// extracted by mini-css-extract-plugin
export var avatar = "_ro-3";
export var avatarContainer = "_ro-2";
export var avatarSpacer = "_ro-5";
export var avatarSpacerContainer = "_ro-4";
export var avatarStackContainer = "_ro-1";
export var bubble = "_ro-0";
export var remainderBubble = "_ro-6";